function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M150.5,238.1L150.5,238.1L150.5,238.1L150.5,238.1z M150.5,307.4L150.5,307.4L150.5,307.4L150.5,307.4z M130.5,157.3L130.5,157.3L130.5,157.3L130.5,157.3z M110.5,168.8L110.5,168.8L110.5,168.8L110.5,168.8z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st1",
  points: "230.5,261.2 230.5,261.2 210.5,272.7 210.5,272.7 210.5,249.6 210.5,249.6 \t"
}), React.createElement("polygon", {
  className: "st1",
  points: "210.5,272.7 210.5,272.7 190.5,284.3 190.5,284.3 190.5,261.2 190.5,261.2 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "370.5,249.6 370.5,295.8 350.5,307.4 350.5,261.2 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "290.5,295.8 290.5,342 270.5,353.6 270.5,353.6 270.5,307.4 270.5,307.4 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "390.5,122.6 390.5,307.4 370.5,318.9 370.5,134.2 \t"
}), React.createElement("polygon", {
  className: "st1",
  points: "150.5,215 150.5,307.4 130.5,318.9 130.5,203.5 130.5,203.5 \t"
}), React.createElement("polygon", {
  className: "st1",
  points: "190.5,191.9 190.5,215 170.5,226.5 170.5,226.5 170.5,203.5 170.5,203.5 \t"
}), React.createElement("polygon", {
  className: "st1",
  points: "170.5,157.3 170.5,180.4 150.5,191.9 150.5,191.9 150.5,168.8 150.5,168.8 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "310.5,261.2 310.5,307.4 290.5,318.9 290.5,272.7 290.5,272.7 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "330.5,226.5 330.5,272.7 310.5,284.3 310.5,238.1 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "350.5,238.1 350.5,284.3 330.5,295.8 330.5,249.6 \t"
}), React.createElement("polygon", {
  className: "st2",
  points: "270.5,191.9 270.5,376.7 250.5,388.2 250.5,203.5 \t"
}), React.createElement("polygon", {
  className: "st1",
  points: "150.5,122.6 150.5,145.7 130.5,157.3 130.5,157.3 130.5,134.2 \t"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st3",
  points: "310.5,261.2 310.5,261.2 290.5,272.7 290.5,272.7 270.5,261.2 290.5,249.6 \t\t"
})), React.createElement("polygon", {
  className: "st3",
  points: "290.5,295.8 290.5,295.8 270.5,307.4 270.5,307.4 270.5,284.3 270.5,284.3 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "350.5,238.1 350.5,238.1 330.5,249.6 330.5,226.5 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "370.5,249.6 350.5,261.2 350.5,238.1 350.5,238.1 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "190.5,215 190.5,238.1 170.5,226.5 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "210.5,203.5 210.5,226.5 190.5,215 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "230.5,191.9 230.5,215 210.5,203.5 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "390.5,122.6 390.5,122.6 370.5,134.2 350.5,122.6 350.5,122.6 370.5,111.1 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "170.5,157.3 170.5,157.3 150.5,168.8 150.5,168.8 130.5,157.3 150.5,145.7 150.5,145.7 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "150.5,122.6 130.5,134.2 110.5,122.6 130.5,111.1 130.5,111.1 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "330.5,226.5 330.5,226.5 310.5,238.1 290.5,226.5 310.5,215 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "190.5,191.9 190.5,191.9 170.5,203.5 170.5,203.5 150.5,191.9 170.5,180.4 170.5,180.4 \t"
}), React.createElement("polygon", {
  className: "st3",
  points: "270.5,191.9 270.5,191.9 250.5,203.5 230.5,191.9 250.5,180.4 250.5,180.4 \t"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st4",
  points: "330.5,272.7 330.5,295.8 310.5,284.3 \t"
}), React.createElement("polygon", {
  className: "st4",
  points: "350.5,284.3 350.5,307.4 330.5,295.8 330.5,295.8 \t"
}), React.createElement("polygon", {
  className: "st4",
  points: "370.5,295.8 370.5,318.9 350.5,307.4 \t"
}), React.createElement("polygon", {
  className: "st4",
  points: "370.5,134.2 370.5,249.6 350.5,238.1 350.5,238.1 350.5,122.6 \t"
}), React.createElement("polygon", {
  className: "st4",
  points: "290.5,272.7 290.5,295.8 270.5,284.3 270.5,284.3 270.5,261.2 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "130.5,134.2 130.5,318.9 110.5,307.4 110.5,168.8 110.5,168.8 110.5,168.8 110.5,122.6 \t"
}), React.createElement("polygon", {
  className: "st4",
  points: "310.5,238.1 310.5,261.2 290.5,249.6 290.5,226.5 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "210.5,226.5 210.5,272.7 190.5,261.2 190.5,261.2 190.5,215 190.5,215 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "230.5,215 230.5,261.2 210.5,249.6 210.5,249.6 210.5,203.5 210.5,203.5 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "190.5,238.1 190.5,284.3 170.5,272.7 170.5,272.7 170.5,226.5 170.5,226.5 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "170.5,203.5 170.5,249.6 150.5,238.1 150.5,238.1 150.5,191.9 150.5,191.9 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "150.5,168.8 150.5,215 130.5,203.5 130.5,203.5 130.5,157.3 130.5,157.3 \t"
}), React.createElement("polygon", {
  className: "st5",
  points: "250.5,203.5 250.5,388.2 230.5,376.7 230.5,191.9 230.5,191.9 \t"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Ebene_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      "enableBackground": "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/logo.e014f8a5.svg";
export { SvgComponent as ReactComponent };